export class HttpClientHelper {
  // 7077

  // static baseURL: string = "https://localhost:5006/api/";
  // static imageUrl: string = " https://localhost:5006/uploads/";
  // static downloadUrl: string = "https://localhost:5006/uploads/";
  // static URL: string = "http://195.201.134.237:7077";



  // static baseURL: string = "https://sq4ex.com:7070/api/";
  // static imageUrl: string = "https://sq4ex.com:7070/uploads/";
  // static downloadUrl: string = "https://sq4ex.com:7070/uploads/";
  // static URL: string = "https://sq4ex.com:7070/";


  static baseURL: string = "https://api.mohseniex.com/api/";
  static imageUrl: string = "https://api.mohseniex.com/uploads/";
  static downloadUrl: string = "https://api.mohseniex.com/uploads/";
  static URL: string = "https://api.mohseniex.com/";
}
